import React, { useEffect, useState } from "react";
import { Trophy, Eye } from "lucide-react";
import { API_URL } from "../config";
import { useSpecialty } from "../SpecialtyContext";

export default function TopAuthorsWidget({ global = false }) {
  const [authors, setAuthors] = useState([]);
  const [period, setPeriod] = useState("all"); // "all" | "month"
  const [sort, setSort] = useState("views");      // "views" | "count"
  const { specialty } = useSpecialty();

  useEffect(() => {
    const params = new URLSearchParams({ limit: 5 });
    if (!global && specialty?.id) params.set("specialty", specialty.id);
    if (period === "month") params.set("days", "30");
    if (sort === "count") params.set("sort", "count");
    fetch(`${API_URL}/authors/top?${params}`)
      .then(r => r.ok ? r.json() : [])
      .then(setAuthors)
      .catch(() => setAuthors([]));
  }, [specialty, global, period, sort]);

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, fontWeight: 700, color: "#007c84", fontSize: "0.95rem" }}>
          <Trophy size={16} strokeWidth={2.2} /> Топ авторов
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {[
            { value: sort, set: setSort, items: [{ id: "views", label: "По просмотрам" }, { id: "count", label: "По публикациям" }] },
            { value: period, set: setPeriod, items: [{ id: "all", label: "Всё время" }, { id: "month", label: "Этот месяц" }] },
          ].map((group, gi) => (
            <div key={gi} style={{ display: "flex", gap: 2, background: "#f2f2fb", borderRadius: 7, padding: 2 }}>
              {group.items.map(t => (
                <button
                  key={t.id}
                  onClick={() => group.set(t.id)}
                  style={{
                    border: "none", borderRadius: 5, padding: "3px 9px", fontSize: "0.76rem", cursor: "pointer",
                    background: group.value === t.id ? "#fff" : "transparent",
                    color: group.value === t.id ? "#007c84" : "#888",
                    fontWeight: group.value === t.id ? 700 : 500,
                    boxShadow: group.value === t.id ? "0 1px 2px rgba(0,0,0,0.08)" : "none",
                  }}
                >
                  {t.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
      {authors.length === 0 ? (
        <p style={{ color: "#999", fontSize: "0.85rem", fontStyle: "italic", margin: 0 }}>
          {period === "month" ? "За этот месяц пока нет публикаций." : "Пока нет данных."}
        </p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {authors.map((a, idx) => (
            <div key={a.author} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.9rem" }}>
              <span style={{ color: "#aaa", fontWeight: 700, width: 18 }}>{idx + 1}.</span>
              <span style={{ color: "#333", flex: 1 }}>{a.author}</span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#888", fontSize: "0.8rem" }}>
                {a.content_count} публ. · <Eye size={12} strokeWidth={2} /> {a.total_views}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
